<template>
  <div
    class="d-search-results"
    :class="{ 'popup': isPopup }"
  >
    <div
      v-if="(alwaysDisplayed || isDisplayed)"
      class="search-results-container"
    >
      <div
        v-if="isLoading"
        class="loading-container"
      >
        <DuiLoadingIndicator />
      </div>

      <div v-else>
        <div
          v-if="isEmpty"
          class="no-results"
        >
          No results.
        </div>

        <div
          v-else
          class="result-entries"
        >
          <DSearchResultsGroup
            v-for="typeResults in groupedResults"
            :key="typeResults.type"
            :results-group="typeResults"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DSearchResultsGroup from './d-search-results-group/d-search-results-group.vue';
import KEY_CODES from '@dui/helpers/key-codes';

export default {
  components: {
    DSearchResultsGroup,
  },
  props: {
    alwaysDisplayed: {
      type: Boolean,
      default: false,
    },
    isPopup: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isDisplayed: false,
  }),
  computed: {
    groupedResults() {
      return this.$store.getters['Search/get-grouped-results'];
    },
    isEmpty() {
      return this.$store.getters['Search/get-empty-state'];
    },
    isLoading() {
      return this.$store.getters['Search/get-loading-state'];
    },
  },
  beforeDestroy() {
    this.removeEventListeners();
  },
  methods: {
    toggleDisplayed(isDisplayed) {
      if (this.alwaysDisplayed) {
        return;
      }

      if (this.isDisplayed === isDisplayed) {
        return;
      }

      this.$set(this, 'isDisplayed', isDisplayed);

      if (!this.isDisplayed) {
        this.removeEventListeners();
        return;
      }

      this.addEventListeners();
    },

    // Events
    addEventListeners() {
      document.addEventListener('mousedown', this.windowClickPerformed);
      window.addEventListener('keydown', this.keyUpPerformed);
    },

    keyUpPerformed(ev) {
      if (ev.keyCode !== KEY_CODES.ESCAPE) {
        return;
      }

      this.toggleDisplayed(false);
    },

    removeEventListeners() {
      document.removeEventListener('mousedown', this.windowClickPerformed);
      window.removeEventListener('keydown', this.keyUpPerformed);
    },

    windowClickPerformed(ev) {
      if (this.$el.contains(ev.target)) {
        return;
      }

      this.toggleDisplayed(false);
    },
    // END Events
  },
};
</script>

<style lang="scss">
@import '@dui-styles/base';

.d-search-results {
  .loading-container {
    padding: $_1em;
    text-align: center;
  }

  .no-results {
    padding: $_1em;
    text-align: center;
  }

  .search-results-container {
    .d-search-results-group {
      border-bottom: $border-width-base solid getColor($grey);
    }
  }

  &.popup {
    .search-results-container {
      background-color: getColor($white);
      border: $border-width-base solid getColor($grey, fade);
      border-radius: $border-radius-base;
      box-shadow: $box-shadow-context-menu;
      max-height: 350px;
      overflow: auto;
      z-index: 1;

      @include scrollBar();

      .d-search-results-group > strong,
      .d-search-results-group .d-search-result a {
        padding-left: $_1-5em;
        padding-right: $_1-5em;
      }
    }
  }
}
</style>
